import { FC } from 'react';
import { Global } from 'theme-ui';

export const SignInGlobalStyles: FC = () => {
  return (
    <Global
      styles={{
        '.page-main': {
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 0,
        },

        '#sign-in-page-root': {
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 0',
        },
      }}
    />
  );
};
